module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._m(0), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "open": false,
      "position": "is-bottom",
      "aria-id": "contentIdForA11y1"
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function(props) {
        return _c('a', {
          attrs: {
            "aria-controls": "contentIdForA11y1"
          }
        }, [_c('b-icon', {
          attrs: {
            "icon": !props.open ? 'menu-down' : 'menu-up'
          }
        }), _vm._v("\n                " + _vm._s(!props.open ? 'All options' : 'Fewer options') + "\n            ")], 1)
      }
    }])
  }, [_c('p', [_vm._v("\n                Lorem ipsum dolor sit amet, consectetur adipiscing elit. "), _c('br'), _vm._v("\n                Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus, nec rutrum justo nibh eu lectus. "), _c('br'), _vm._v("\n                Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel, interdum mattis neque.\n            ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("\n                Subtitle\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Lorem ipsum dolor sit amet, consectetur adipiscing elit. "), _c('br'), _vm._v("\n                Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus, nec rutrum justo nibh eu lectus. "), _c('br'), _vm._v("\n                Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel, interdum mattis neque.\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01310292"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/collapse/examples/ExPosition.vue
// module id = 1026
// module chunks = 19 51